/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import AccountValueVo from './AccountValueVo';




  /**
   * The PagingAccountProgressVo model module.
   * @module clazz_course/model/PagingAccountProgressVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PagingAccountProgressVo</code>.
   * @alias module:clazz_course/model/PagingAccountProgressVo
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>PagingAccountProgressVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/PagingAccountProgressVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/PagingAccountProgressVo} The populated <code>PagingAccountProgressVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'list')) {
        obj['list'] = ApiClient.convertToType(data['list'], [AccountValueVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'hasNextPage')) {
        obj['hasNextPage'] = ApiClient.convertToType(data['hasNextPage'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * 学生列表
   * @member {Array.<module:clazz_course/model/AccountValueVo>} list
   */
  exports.prototype['list'] = undefined;
  /**
   * 是否有下一页
   * @member {Boolean} hasNextPage
   */
  exports.prototype['hasNextPage'] = undefined;



  export default exports;
;


